import React from 'react'
import QuotationManagementPage from './quotation-management-page'

const QuotationOnlyDraft = () => {
	return <QuotationManagementPage isOnlyDraft={true} />
}

export default QuotationOnlyDraft
